// WHAT A CUSTOMER DEALS IN, IN WORDS (db/0101's trade_profile; main dcb3085). The operator, 27 Oct 2026: "Buyer and
// seller /MC /bank transfer etc also should be clearly visible on customer card in the dashboard". The words for the
// party read's { side, methods } — a label on the card only: it changes no booking rail, and "Bank transfer" is how the
// customer said they pay, not a rail the desk takes customer AED in on.
import type { TradeMethod, TradeProfile, TradeSide } from './api';

export const TRADE_SIDE_WORD: Record<TradeSide, string> = { buyer: 'Buyer', seller: 'Seller', both: 'Buyer and seller' };
export const TRADE_METHOD_WORD: Record<TradeMethod, string> = {
  manager_cheque: "Manager's cheque",
  bank_transfer: 'Bank transfer',
  cash: 'Cash',
  crypto: 'Crypto',
  angadiya: 'Angadiya',
};

/** The profile's words, or null when it says nothing: absent (a Worker before dcb3085), or { side: null, methods: [] }
 *  (db/0101 not applied, or nothing known yet). A value outside the vocabulary is left out, never guessed at. */
export function tradeProfileWords(tp: TradeProfile | null | undefined): { side: string | null; methods: string[] } | null {
  if (!tp) return null;
  const side = tp.side ? TRADE_SIDE_WORD[tp.side] ?? null : null;
  const methods = (tp.methods ?? []).map((m) => TRADE_METHOD_WORD[m]).filter((w): w is string => !!w);
  return side || methods.length ? { side, methods } : null;
}

/** THE LIST'S SHORT FORM (Parties, one quiet line a row): "Buyer · MC / Bank transfer" — the operator's own shorthand for
 *  the cheque ("/MC /bank transfer"), the other words as on the card. '' when the profile says nothing. */
export function tradeProfileLine(tp: TradeProfile | null | undefined): string {
  const w = tradeProfileWords(tp);
  if (!w) return '';
  const methods = (tp?.methods ?? []).map((m) => (m === 'manager_cheque' ? 'MC' : TRADE_METHOD_WORD[m])).filter(Boolean);
  return [w.side ?? '', methods.join(' / ')].filter(Boolean).join(' · ');
}
